enum Regions {
    Shoulder,
    Back,
};

export default Regions;